import {
  FaBriefcase,
  FaGlobe,
  FaGraduationCap,
  FaLinkedin,
  FaPalette,
  FaProjectDiagram,
  FaUser,
} from "react-icons/fa";
import { GrContact } from "react-icons/gr";
import { IoLanguageOutline } from "react-icons/io5";

export const personalInformation = {
  name: "Neha Koirala",
  role: "UI/UX Designer",
  location: "Kastrup, Denmark",
  email: "nehakoirala2708@gmail.com",
  phone: "+45 71327922",
  professionalInfo:
    "Aspiring UI/UX Designer transitioning from a business background, with a passion for creating simple, intuitive, and user-centered digital experiences. Currently building UI/UX case studies while developing skills in Figma, wireframing, prototyping, and user research. Alongside my design journey, I am learning Danish and continuously expanding my knowledge through hands-on projects and self-directed learning. I enjoy solving problems, understanding user needs, and turning ideas into meaningful design solutions.",
  personalInfo:
    "Originally from Nepal and now living in Denmark, I’m someone who loves stepping outside my comfort zone. I’m always up for a challenge—especially the kind that feels a little scary, whether that's trying something new, starting conversations with strangers, or taking on experiences I've never had before. When I'm not designing, you'll usually find me vlogging, filming, writing, or organizing absolutely everything. I love capturing moments, telling stories, and documenting life through videos and photos. Moving to a new country taught me to be adaptable, curious, and open to new perspectives. I believe growth comes from saying ´yes´ to opportunities, even when they feel intimidating at first.",
  summary:
    "Aspiring UI/UX designer transitioning from a business background, with a strong focus on creating simple and user friendly digital experiences. Currently building UI/UX case studies and developing skills in Figma, wireframing, and user research.",
  links: [
    {
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/neha-koirala-3241a73a8",
      icon: FaLinkedin,
    },
    { label: "Website", url: "https://nehakoirala.com/", icon: FaGlobe },
  ],
};

export const menuItems = [
  { id: "about", label: "About me", icon: <FaUser /> },
  { id: "experience", label: "Experience", icon: <FaBriefcase /> },
  { id: "projects", label: "Projects", icon: <FaProjectDiagram /> },
  { id: "education", label: "Education", icon: <FaGraduationCap /> },
  { id: "skills", label: "Skills", icon: <FaPalette /> },
  { id: "language", label: "Language", icon: <IoLanguageOutline /> },
  { id: "contact", label: "Contact", icon: <GrContact /> },
];

export const workExperience = [
  {
    role: "Cleaning Assistant",
    company: "Copenhagen Airport, Denmark",
    date: "August 2025 - Present",
    desc: "Worked in structured, high-pressure environments to maintain cleanliness and safety standards across a busy international terminal.",
    tech: [
      "Attention to Detail",
      "Time Management",
      "Team Collaboration",
      "Adaptability",
      "Problem Solving",
    ],
  },
  {
    role: "Waitress / Bartender",
    company: "Marley’s Diner",
    date: "March 2025 - August 2025",
    desc: "Managed multiple customer interactions simultaneously while maintaining a smooth and welcoming dining experience.",
    tech: [
      "Customer Service",
      "Communication",
      "Multitasking",
      "Time Management",
      "Adaptability",
    ],
  },
  {
    role: "Receptionist",
    company: "Boston Educational Services, Nepal",
    date: "2024",
    desc: "Managed front desk operations and scheduling for an educational consultancy, ensuring smooth communication and organisation. Coordinated workflows to improve efficiency and provided excellent service to students and parents.",
    tech: [
      "Stakeholder Communication",
      "Scheduling",
      "Workflow Planning",
      "Project Coordination",
      "Report Writing",
    ],
  },
];

export const internshipsAndTraining = [
  {
    role: "UI/UX Design Training",
    company: "ReDi School, Denmark",
    date: "March 2026 - June 2026",
    desc: "Completed an intensive UI/UX design training program focused on user-centered design principles, wireframing, prototyping, and Figma. Developed practical skills through hands-on projects and case studies, preparing for a career in UI/UX design.",
    tech: [
      "Figma",
      "FigJam",
      "Wireframing",
      "Prototyping",
      "User Research",
      "Design Thinking",
      "Visual Design",
      "Usability Testing",
    ],
  },
  {
    role: "Internship",
    company: "Rastriya Banijya Bank, Nepal",
    date: "November 2024 - January 2025",
    desc: "Supported client onboarding and account setup processes. Assisted customers with account creation and banking services, maintaining accuracy and compliance with procedures.",
    tech: [
      "Attention to Detail",
      "Stakeholder Communication",
      "Business Analysis",
      "Report Writing",
      "Customer Service",
    ],
  },
];

export const hobbyProjects = [
  {
    title: "Mosiak",
    subtitle: "UX/UI Design Case Study",
    desc: "Mosiak is a learning platform for hands-on creative skills like painting, pottery, sewing, and knitting. Instead of spending hours searching for tutorials, users follow clear, visual learning paths that help them create real projects and build practical skills",

    thumbnail: "/mosiak.png",

    prototypeUrl:
      "https://www.figma.com/proto/uYsXcSkXZcLeP1Dme6u24Y/Neha-Koirala?node-id=306-884&t=KQP7CnoDFnbWnqyk-1",
    caseStudyUrl:
      "https://www.figma.com/proto/uYsXcSkXZcLeP1Dme6u24Y/Neha-Koirala?node-id=470-1223&t=KQP7CnoDFnbWnqyk-1",

    status: "Live Prototype",
    year: "2026",

    role: "UI/UX Designer",

    tools: ["Figma"],

    featured: true,
  },
];
export const education = [
  {
    school: "ReDi School",
    degree: "UI Design Training",
    date: "March 2026 - June 2026",
    loc: "Denmark",
  },
  {
    school: "Tribhuvan University",
    degree: "Bachelor in Business Studies",
    date: "2019 - 2023",
    loc: "Biratnagar, Nepal",
  },
  {
    school: "Merryland International College",
    degree: "Higher Secondary Education Board (HSEB)",
    date: "2017 - 2019",
    loc: "Biratnagar",
  },
];

export const skills = {
  design_tools: ["Figma", "FigJam", "Canva"],
  ux_process: [
    "User Research",
    "Wireframing",
    "Prototyping",
    "Usability Testing",
    "Information Architecture",
    "User Journey Mapping",
    "Persona Creation",
    "Design Thinking",
  ],
  ui_design: [
    "Visual Design",
    "Typography",
    "Color Theory",
    "Design Systems",
    "Responsive Design",
    "Accessibility (WCAG)",
    "Component Design",
  ],
  ai_tools: ["ChatGPT", "Claude AI"],
  management: [
    "Project Coordination",
    "Stakeholder Communication",
    "Workflow Planning",
    "Team Collaboration",
    "Business Analysis",
    "Scheduling",
    "Report Writing",
    "Problem Solving",
  ],
};

export const languages = [
  { name: "Nepali", level: "Native", strength: 100 },
  { name: "English", level: "Professional / Fluent", strength: 95 },
  { name: "Danish", level: "Professional", strength: 75 },
  { name: "Hindi", level: "Fluent", strength: 90 },
];
